module.exports = __webpack_public_path__ + "img/writing_novel-hover.5e6547df.svg";